import { render, staticRenderFns } from "./my-info-change.vue?vue&type=template&id=b1373a34&scoped=true&"
import script from "./my-info-change.vue?vue&type=script&lang=js&"
export * from "./my-info-change.vue?vue&type=script&lang=js&"
import style0 from "./my-info-change.vue?vue&type=style&index=0&id=b1373a34&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1373a34",
  null
  
)

export default component.exports